import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

// Version 1 ---------------------
export const ParagraphSettingsV1 = z.object({
  center: z.union([z.literal(true), z.literal(false)]),
  showEmoji: z.union([z.literal(true), z.literal(false)]),
  showTitle: z.union([z.literal(true), z.literal(false)]),
  showTitleRight: z.union([z.literal(true), z.literal(false)]),
  showCaption: z.union([z.literal(true), z.literal(false)]),
  showBody: z.union([z.literal(true), z.literal(false)]),
})

export type TParagraphSettingsV1 = z.infer<typeof ParagraphSettingsV1>

export const ParagraphElementV1 = z.object({
  id: z.string(),
  name: z.literal("paragraph"),
  settings: ParagraphSettingsV1,
  container: ContainerOptionsV1,
})

export type TParagraphElementV1 = z.infer<typeof ParagraphElementV1>

// Latest ---------------------
export const ParagraphSettings = ParagraphSettingsV1
export type TParagraphSettings = TParagraphSettingsV1
export const ParagraphElement = ParagraphElementV1
export type TParagraphElement = TParagraphElementV1
